import { QueryHookOptions, useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import {
  TaxForecastDataDocument,
  TaxForecastDataQuery,
  TaxForecastDataQueryVariables,
} from './taxForecastData.gql';

export const useTaxForecastData = (
  options?: QueryHookOptions<
    TaxForecastDataQuery,
    TaxForecastDataQueryVariables
  >,
) => {
  const { companyProfileId } = useCompanyContext();

  const { data, ...hook } = useQuery(TaxForecastDataDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId ?? '' },
    ...options,
  });

  const currentTaxForecastPeriodId =
    data?.viewer.company.currentTaxForecastPeriod?.taxForecastPeriodId;
  const taxForecastPeriods =
    data?.viewer.company.taxForecastPeriods.edges.map(({ node }) => node) ?? [];

  const currentTaxForecastPeriod = taxForecastPeriods.find(
    (period) => period.taxForecastPeriodId === currentTaxForecastPeriodId,
  );

  return {
    currentTaxForecastPeriod,
    currentTaxForecastPeriodId,
    taxForecastPeriods,
    taxForecastProfile: data?.viewer.company.taxForecastProfile,
    ...hook,
  };
};

export type CurrentTaxForecastPeriod = NonNullable<
  Awaited<ReturnType<typeof useTaxForecastData>>['currentTaxForecastPeriod']
>;

export type TaxForecastProfile = NonNullable<
  Awaited<ReturnType<typeof useTaxForecastData>>['taxForecastProfile']
>;

export type TaxForecastPeriod = NonNullable<
  Awaited<ReturnType<typeof useTaxForecastData>>['taxForecastPeriods']
>[number];
